import { IAuthGateway, AuthChangePresenterFunc, PresenterFunc, IUserGateway } from '@/core/interface';
import { AuthService } from '@/core/usecase';

export class AuthController {
  private readonly service: AuthService;

  constructor(authGateway: IAuthGateway) {
    this.service = new AuthService(authGateway);
  }

  public changePassword(oldPassword: string, newPassword: string, presenter: PresenterFunc<void>) {
    this.service.changePassword(oldPassword, newPassword, presenter);
  }

  public reset(email: string, presenter: PresenterFunc<void>) {
    this.service.reset(email, presenter);
  }

  public signIn(email: string, password: string, presenter: AuthChangePresenterFunc) {
    this.service.signIn(email, password, presenter);
  }

  public signOut(presenter: AuthChangePresenterFunc) {
    this.service.signOut(presenter);
  }
}
